import * as ambassadorWixBillingV1TaxGroup from './billing-v1-tax-group-tax-groups.http.js';
import * as ambassadorWixBillingV1TaxGroupTypes from './billing-v1-tax-group-tax-groups.types.js';
import * as ambassadorWixBillingV1TaxGroupUniversalTypes from './billing-v1-tax-group-tax-groups.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createTaxGroup(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1TaxGroupUniversalTypes.CreateTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupTypes.CreateTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.CreateTaxGroupResponse,
  ambassadorWixBillingV1TaxGroupTypes.CreateTaxGroupResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.createTaxGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tax-groups',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTaxGroup(): __PublicMethodMetaInfo<
  'GET',
  { taxGroupId: string },
  ambassadorWixBillingV1TaxGroupUniversalTypes.GetTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupTypes.GetTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.GetTaxGroupResponse,
  ambassadorWixBillingV1TaxGroupTypes.GetTaxGroupResponse
> {
  const payload = { taxGroupId: ':taxGroupId' } as any;

  const getRequestOptions = ambassadorWixBillingV1TaxGroup.getTaxGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tax-groups/{taxGroupId}',
    pathParams: { taxGroupId: 'taxGroupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTaxGroup(): __PublicMethodMetaInfo<
  'PATCH',
  { taxGroupId: string },
  ambassadorWixBillingV1TaxGroupUniversalTypes.UpdateTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupTypes.UpdateTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.UpdateTaxGroupResponse,
  ambassadorWixBillingV1TaxGroupTypes.UpdateTaxGroupResponse
> {
  const payload = { taxGroup: { id: ':taxGroupId' } } as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.updateTaxGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/tax-groups/{taxGroup.id}',
    pathParams: { taxGroupId: 'taxGroupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteTaxGroup(): __PublicMethodMetaInfo<
  'DELETE',
  { taxGroupId: string },
  ambassadorWixBillingV1TaxGroupUniversalTypes.DeleteTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupTypes.DeleteTaxGroupRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.DeleteTaxGroupResponse,
  ambassadorWixBillingV1TaxGroupTypes.DeleteTaxGroupResponse
> {
  const payload = { taxGroupId: ':taxGroupId' } as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.deleteTaxGroup(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/tax-groups/{taxGroupId}',
    pathParams: { taxGroupId: 'taxGroupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryTaxGroups(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1TaxGroupUniversalTypes.QueryTaxGroupsRequest,
  ambassadorWixBillingV1TaxGroupTypes.QueryTaxGroupsRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.QueryTaxGroupsResponse,
  ambassadorWixBillingV1TaxGroupTypes.QueryTaxGroupsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.queryTaxGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tax-groups/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDefaultTaxGroups(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsRequest,
  ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsResponse,
  ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.listDefaultTaxGroups(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/tax-groups/default-tax-groups',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDefaultTaxGroupsByAppIds(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsByAppIdsRequest,
  ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsByAppIdsRequest,
  ambassadorWixBillingV1TaxGroupUniversalTypes.ListDefaultTaxGroupsByAppIdsResponse,
  ambassadorWixBillingV1TaxGroupTypes.ListDefaultTaxGroupsByAppIdsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBillingV1TaxGroup.listDefaultTaxGroupsByAppIds(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/tax-groups/list-default-tax-groups-by-app-ids',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TaxGroup as TaxGroupOriginal,
  CreateTaxGroupRequest as CreateTaxGroupRequestOriginal,
  CreateTaxGroupResponse as CreateTaxGroupResponseOriginal,
  GetTaxGroupRequest as GetTaxGroupRequestOriginal,
  GetTaxGroupResponse as GetTaxGroupResponseOriginal,
  UpdateTaxGroupRequest as UpdateTaxGroupRequestOriginal,
  UpdateTaxGroupResponse as UpdateTaxGroupResponseOriginal,
  DeleteTaxGroupRequest as DeleteTaxGroupRequestOriginal,
  DeleteTaxGroupResponse as DeleteTaxGroupResponseOriginal,
  QueryTaxGroupsRequest as QueryTaxGroupsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryTaxGroupsResponse as QueryTaxGroupsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  ListDefaultTaxGroupsRequest as ListDefaultTaxGroupsRequestOriginal,
  ListDefaultTaxGroupsResponse as ListDefaultTaxGroupsResponseOriginal,
  ListDefaultTaxGroupsByAppIdsRequest as ListDefaultTaxGroupsByAppIdsRequestOriginal,
  ListDefaultTaxGroupsByAppIdsResponse as ListDefaultTaxGroupsByAppIdsResponseOriginal,
  ListDefaultTaxGroupsByAppIdsResult as ListDefaultTaxGroupsByAppIdsResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  UpdateTaxGroupApplicationErrors as UpdateTaxGroupApplicationErrorsOriginal,
} from './billing-v1-tax-group-tax-groups.types.js';
